export const liveKitCallbacks = {
    updateTranscriptions: (segments) => {
        console.log(JSON.stringify(segments, undefined, 2));
    }
};
